import PopoverToolbarItem from './PopoverToolbarItem';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
/*
import ColorPicker from './ColorPicker';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import CollapsibleSection from './CollapsibleSection';
*/
import ColorBox from './ColorBox';


const styleOptions = ["0 0","2 1", "2 2", "3 1","3 2","4 1", "4 2"]


function Checkbox({checked,property,onPropertyChange,...inputProps}){
  return (

    <td>
      <input checked={checked} onChange={e => {
        let display = e.target.checked?"visible":"hidden";
        onPropertyChange({
          properties:{
            [property]:display
          }
        })
      }} type={"checkbox"} {...inputProps} />
    </td>
  )
}



const REGION_OUTLINE_VISIBLE = "style.visibility";
const LEADER_LINES_VISIBLE = "leaderLines.style.visibility";

export default function RegionSpecificMenu({ regionId, onEvent, data }){


  let { borderThickness=1, borderColor="white", color="white", strokeDasharray="0 0" } = data?.style || {};

  let checked = data?.style?.visibility !== "hidden";
  let leaderLinesChecked = (
    checked && 
    data?.leaderLines?.style?.visibility !== "hidden"
  );

  function onPropertyChange(change){
    onEvent && onEvent({type:"propertyChange",...change});
  }

  console.log({leaderLinesChecked});


  return (
    <>
      <tr onMouseDown={e => {
        e.stopPropagation();
      }}>

        <Checkbox key={"box-visible-"+checked} checked={checked} property={REGION_OUTLINE_VISIBLE} onPropertyChange={onPropertyChange}/>

        <Checkbox key={"lines-visible-"+leaderLinesChecked} checked={leaderLinesChecked} property={LEADER_LINES_VISIBLE} onPropertyChange={onPropertyChange} {...{disabled:!checked}}/>


        {/*<>
        <td>
          <input checked={checked} onChange={e => {
            let display = e.target.checked?"visible":"hidden";
            onPropertyChange({
              properties:{
                "style.visibility":display
              }
            })
          }} type={"checkbox"} />
        </td>

        <td>
          <input 
            disabled={!checked}
            checked={leaderLinesChecked} 
            onChange={e => {
              let display = e.target.checked?"visible":"hidden";
              onPropertyChange({
                type:"propertyChange",
                properties:{
                  :display
                }
              })
            }}

          type={"checkbox"} />
        </td>
        </>*/}



        <td>
          <input 
            //disabled={!checked}
            key={"checked-"+Math.random()}
            
            
            menuItem={"region-outline-border-width"}
            disabled={!checked}

            
            
            onChange={e => {
              debugger;

            onPropertyChange({

              properties:{
                "style.borderThickness":Number(e.target.value)
              }
            })
          }} value={borderThickness} style={{
          width:34, fontSize:10,
            pointerEvents:'auto',
          }} min={1} type="number"/>
        </td>



        <td style={{paddingLeft:3}}>
          <Select
            disabled={!checked}
            //onClick={e => e.preventDefault()}
            labelId="demo-simple-select-outlined-label"
            id="subregion-outline-style"
            value={strokeDasharray}
            style={{
              width:28,
              //paddingLeft:3,
              border:'1px solid #666',
              fontSize:10,
              height:18,
              borderRadius:2,
              background:'white',
              overflow:'hidden',
              textOverflow:'clip',
            }}
            onChange={e => onPropertyChange({
              properties:{
                "style.strokeDasharray":e.target.value
              }
            })}
            IconComponent={() => <div/>}
          >
            {styleOptions.map(value => {
              return (
                <MenuItem style={{ 
                  //padding:5,
                  overflow:'hidden',
                  textOverflow:'clip',
                  whiteSpace:'normal',
                  }} value={value}>
                  <svg style={{
                    //paddingTop:5,
                    margin:3,
                    //border:'1px solid blue'
                    }}
                    width={20} height={10}>
                    <line x1={0} y1={"50%"} x2={"100%"} y2={"50%"} {...{
                      stroke:"black",
                      strokeDasharray:value||"0 0"
                    }}/>
                  </svg>
                </MenuItem>
              )
            })}
          </Select>



        </td>
        <td menuItem={"region-outline-border-color"}>
          <PopoverToolbarItem 
            disabled={!checked}
            unifiedGroup={{style:{color:borderColor}}}
            item={{
            icon:<ColorBox color={borderColor}/>,
            subToolbar:[{
              scope:'local',
              valueToSet:'color',
              styleProperty:'color',
              type:'color',

              onChange:borderColor => {
                onPropertyChange({ properties:{ 
                  "style.borderColor":borderColor
                } })
              }
            }],

            


            

          }}
          {...{

            anchorOrigin:{
              vertical:"top",
              horizontal:"right"
            },

            transformOrigin:{
              vertical:"bottom",
              horizontal:"left",
            }
          }}

          />
        </td>
      </tr>

      <tr>
        <td>
          {null && JSON.stringify(data)}
        </td>
      </tr>
          </>


  )


}
